import styled from 'styled-components'

import OnboardingForm from '../../components/forms/OnboardingForm'

export const Content = styled.div`
  display: flex;
  flex-grow: 1;
  width: 100%;
`

export const Form = styled(OnboardingForm)``
